import { render, staticRenderFns } from "./DetailRight.vue?vue&type=template&id=a51f3388&scoped=true&"
import script from "./DetailRight.vue?vue&type=script&lang=js&"
export * from "./DetailRight.vue?vue&type=script&lang=js&"
import style0 from "./DetailRight.vue?vue&type=style&index=0&id=a51f3388&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51f3388",
  null
  
)

export default component.exports